module.exports = __webpack_public_path__ + "img/brand-business-platform@3x.dcaffdd1.png";